import React, { useEffect, useState, useCallback } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react"
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import Preloader from "./components/Preloader";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Projects from "./pages/Projects";
import Leadership from "./pages/Leadership";
import Contact from "./pages/Contact";
import ComingSoon from "./pages/ComingSoon";

const isComingSoon = process.env.REACT_APP_COMING_SOON === "true";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  const [showPreloader, setShowPreloader] = useState(() => {
    // Only show preloader once per session
    return !sessionStorage.getItem("prayosha_visited");
  });

  const handlePreloaderComplete = useCallback(() => {
    sessionStorage.setItem("prayosha_visited", "true");
    setShowPreloader(false);
  }, []);

  if (isComingSoon) {
    return (
      <>
        <ComingSoon />
        <Analytics />
        <SpeedInsights />
      </>
    );
  }

  return (
    <div className="App">
      {showPreloader && <Preloader onComplete={handlePreloaderComplete} />}
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/leadership" element={<Leadership />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
      <Analytics />
      <SpeedInsights />
    </div>
  );
}

export default App;
